import User1 from '../assets/sound/Buzzer_Helloween_Andi.mp3';
import User2 from '../assets/sound/Buzzer_Helloween_Markus.mp3';
import User3 from '../assets/sound/Buzzer_Helloween_Michael.mp3';
import User4 from '../assets/sound/Buzzer_4_EpicaLDC_Janosch.mp3';
import roles from './roles.js';

const users = [
  {
    name: "Andi",
    role: roles.ROLE_PLAYER,
    soundFile: User1
  },
  {
    name: "Markus",
    role: roles.ROLE_PLAYER,
    soundFile: User2
  },
  {
    name: "Michael",
    role: roles.ROLE_PLAYER,
    soundFile: User3
  },
  {
    name: "Moderator",
    role: roles.ROLE_HOST,
    soundFile: User4
  },
];

export default users;



// WEBPACK FOOTER //
// ./src/config/users.js